import { format, parse } from 'date-fns';
import { DateString } from '../calendar-input/definitions';

export interface CalendarRange {
  start: DateString | null;
  end: DateString | null;
}

export const toDateString = (date: Date): DateString => {
  return format(date, 'yyyy-MM-dd') as DateString;
};

export const fromDateString = (dateString: DateString): Date => {
  return parse(dateString, 'yyyy-MM-dd', new Date());
};
